module.exports = __webpack_public_path__ + "img/img-a31526a9.8d41517a.png";